<script>
	import BaseRightMenu from '../BaseRightMenu';
	import ProfileMenuModalInfo from './ProfileMenuModalInfo/index';
	import ProfileMenuModalPassword from './ProfileMenuModalPassword/index';
	import { RemoveAllTokens } from '../../services/TokenService';
  import { LOGOUT_URL} from "@/defaults";
  import {URL_IMG} from "@/defaults";
  import {generateTimestamp} from "@/utils/helperFunction";


	export default {
    data(){
      return {
        URL_IMG: URL_IMG
      }
    },
		name: 'ProfileMenu',
		components: {
			BaseRightMenu,
			ProfileMenuModalInfo,
			ProfileMenuModalPassword,
		},
		props: {
			className: {
				type: String,
				default: '',
			},
		},
		methods: {
      async Logout()
			{
        try {
          await this.$api.post('users/logout', {
            userId: this.$store.state.userProfile.id,
            leaveTime: generateTimestamp()
          })
          RemoveAllTokens();
        } catch (error) {
          console.log(error)
        }
				this.$store.state.permissionList = [];
				this.$store.state.userProfile = {};

        if(!window.location.href.includes('is_dev')){
          window.location.href = LOGOUT_URL;
        }
			},

      hideNavigationMenu(value) {
        if(value.target.localName !== 'svg' && value.target.localName !== 'path'){
          this.$store.state.profileActiveClass = ''
        }
      }


      // ChangeLang(lang)
      // {
      // 	this.$i18n.locale = lang;
      // 	localStorage.setItem('lang', lang);
      //
      // 	this.$api
      // 		.post('/users/change/language', {
      // 			langCode: lang,
      // 		});
      // },
		}
	};
</script>

<template src="./template.html"></template>
